var React = require('react');

function NumberStoryTriangleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M56.4892 43.0701L54.1333 90.4623L0.00370575 39.8152L56.4892 43.0701Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M98.0819 24.1167L54.0616 90.496L56.4367 43.1644L98.0819 24.1167Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M98.0781 24.1162L56.4623 43.1505L-0.00125454 39.8163L98.0781 24.1162Z","fill":"#5915C7","key":2})]);
}

NumberStoryTriangleMobile.defaultProps = {"width":"76","height":"103","viewBox":"0 0 76 103","fill":"none"};

module.exports = NumberStoryTriangleMobile;

NumberStoryTriangleMobile.default = NumberStoryTriangleMobile;
